export default __webpack_public_path__ + "static/media/status-donotdisturb.b81d2803.svg";